import { Fragment, useRef, useState } from 'react'
import { CFlexBetween, FlexColumn } from '../../styles/CommonStyles'
import {
    Body,
    LinkWrapper,
    MLink,
    NavItemWrapper,
    NavText,
    ExitWrapper,
    ExitText,
    ExitIcon,
    RespBody,
    SubLink,
    SubLinkContainer,
} from '../../styles/layout-styles/SideBarStyles'
import {
    FaShieldAlt,
    FaWallet,
    FaSortAmountUpAlt,
    FaHistory,
    FaColumns,
    FaIdBadge,
    FaSortAmountDownAlt,
    FaBuffer,
    FaRocketchat,
    FaRegIdCard,
    FaCaretDown,
    FaCaretUp,
    FaArrowAltCircleUp,
    FaArrowAltCircleDown,
    FaRegUser,
    FaEquals,
} from 'react-icons/fa'
import { MdFace, MdNotificationsActive, MdGetApp } from 'react-icons/md'
import Text from '../../core/utils/Text'
import { CLOSE_SIDEBAR_SIZE, TABLET_SIZE } from '../../core/constants/common'
import { useWalletContext } from '../../core/contexts/wallet'
import { Link, useNavigate } from 'react-router-dom'
import { useLogout } from '../../core/services/react-query/useAuthQuery'
import useClickOutside from '../../core/hooks/useClickOutside'
import { useWindowSize } from '../../core/hooks/useWindowSize'
import { HOME } from '../../core/constants/urls'
import { useMainContext } from '../../core/contexts/main'
import { useAuthContext } from '../../core/contexts/auth'


const Sidebar = ({ windowSize, isOpen, setIsMenuOpen }) => {
    const {
        main: { theme, lang },
    } = useMainContext()
    const { wallet, setWallet } = useWalletContext()
    const { logout } = useAuthContext()
    const { width } = useWindowSize()

    const navigate = useNavigate()
    const [activeTab, setActiveTab] = useState(window.location.pathname)
    const [subLinkOpen, setSubLinkOpen] = useState(
        activeTab === '/user/wallets' || activeTab === '/user/wallet-operations'
    )

    const sideRef = useRef()
    useClickOutside(sideRef, () => {
        setIsMenuOpen(false)
    })

    const onLinkClicked = (nav) => {
        // setIsMenuOpen(false)

        if (nav.route === '/') {
            window.location.href = HOME + lang
        }

        // if (window.location.pathname !== `/user${nav.route}`) {
        setActiveTab(nav.route)
        navigate(nav.route)
        // }

        // if (nav.route === '/wallets') {
        // 	setSubLinkOpen((state) => !state)
        // }
    }

    // operations: deposit, withdraw
    const onSubLinkClicked = (op) => {
        setIsMenuOpen(false)
        setWallet({ op, type: 'coin' })
        navigate('/wallet-operations')
    }

    const variants = {
        in: {
            x: 0,
            transition: { duration: 0.3 },
        },
        out: {
            x: 300,
            transition: { duration: 0.3 },
        },
    }

    const SideBody = () => {
        return (
            <CFlexBetween ref={sideRef} resp={width < TABLET_SIZE}>
                <FlexColumn>
                    <LinkWrapper>
                        <a href={HOME + lang} key={'home'}>
                            <MLink _theme={theme}>
                                <NavItemWrapper>
                                    <FaEquals />
                                    <NavText>
                                        <Text tid={'main'} />
                                    </NavText>
                                </NavItemWrapper>
                            </MLink>
                        </a>
                        {navigations.map((nav) => {
                            if (
                                width > CLOSE_SIDEBAR_SIZE &&
                                nav.text === 'main'
                            ) {
                                return
                            }

                            return (
                                <Link to={nav.route} key={nav.route}>
                                    <MLink
                                        _theme={theme}
                                        active={
                                            activeTab === `/user${nav.route}`
                                        }
                                    // onClick={(e) => {
                                    // 	e.preventDefault()

                                    // 	// onLinkClicked(nav)
                                    // }}
                                    >
                                        <NavItemWrapper>
                                            <nav.icon />
                                            <NavText>
                                                <Text tid={nav.text} />
                                            </NavText>
                                            {/* <p
												className={'p-2'}
												onClick={(e) => {
													e.preventDefault()
													e.stopPropagation()

													setSubLinkOpen(!subLinkOpen)
												}}
											>
												{nav.text === 'my-wallet' &&
                                                    (subLinkOpen ? <FaCaretUp /> : <FaCaretDown />)}
											</p> */}
                                        </NavItemWrapper>
                                    </MLink>
                                    {/* {nav.text === 'my-wallet' && subLinkOpen && (
                                        <>
                                            <SubLink
                                                onClick={() => onSubLinkClicked('deposit')}
                                                active={wallet.op === 'deposit' && activeTab === '/user/wallet-operations'}
                                            >
                                                <SubLinkContainer>
                                                    <FaArrowAltCircleUp style={{ margin: '0 10px' }} />
                                                    <Text tid='deposit-wallet' />
                                                </SubLinkContainer>
                                            </SubLink>
                                            <SubLink
                                                onClick={() => onSubLinkClicked('withdraw')}
                                                active={wallet.op === 'withdraw' && activeTab === '/user/wallet-operations'}
                                            >
                                                <SubLinkContainer>
                                                    <FaArrowAltCircleDown style={{ margin: '0 10px' }} />
                                                    <Text tid='withdraw-wallet' />
                                                </SubLinkContainer>
                                            </SubLink>
                                        </>
                                    )} */}
                                </Link>
                            )
                        })}
                    </LinkWrapper>
                </FlexColumn>
                <ExitWrapper onClick={() => logout()}>
                    <ExitIcon />
                    <ExitText>
                        <Text tid='exit' />
                    </ExitText>
                </ExitWrapper>
            </CFlexBetween>
        )
    }

    return (
        <>
            {windowSize.width < CLOSE_SIDEBAR_SIZE ? (
                <RespBody
                className='shadow-md'
                    variants={variants}
                    initial='out'
                    animate={
                        windowSize.width < CLOSE_SIDEBAR_SIZE &&
                        (isOpen ? 'in' : 'out')
                    }>
                    <SideBody />
                </RespBody>
            ) : (
                <Body>
                    <SideBody />
                </Body>
            )}
        </>
    )
}

const navigations = [
    // { text: 'main', route: HOME, icon: FaEquals, external: true },
    { text: 'dashboard', route: '/dashboard', icon: FaColumns },
    { text: 'profile', route: '/profile', icon: FaRegUser },
    { text: 'security', route: '/security', icon: FaShieldAlt },
    { text: 'authentication', route: '/authentication', icon: FaIdBadge },
    { text: 'my-wallet', route: '/wallets', icon: FaWallet },
    {
        text: 'transaction-history',
        route: '/transaction-history',
        icon: FaSortAmountDownAlt,
    },
    {
        text: 'current-orders',
        route: '/current-orders',
        icon: FaSortAmountUpAlt,
    },
    { text: 'orders-history', route: '/orders-history', icon: FaHistory },
    { text: 'otc-orders', route: '/otc-history', icon: FaBuffer },
    { text: 'cards-accounts', route: '/accounts-cards', icon: FaRegIdCard },
    { text: 'automatic-withdraw', route: '/automatic-withdraw', icon: MdGetApp },
    // { text: 'my-tickets', route: '/tickets', icon: FaRocketchat },
    {
        text: 'my-notifications',
        route: '/notifications',
        icon: MdNotificationsActive,
    },
    { text: 'invite-friends', route: '/invite', icon: MdFace },
]

export default Sidebar
